import moment from 'moment';
import DirectoryStore from '../store/DirectoryStore';
import { Button, Input, Checkbox, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
// новые фильтры с новым форматом дат
// также отходим от значения 'данных нет'
const getFiltersInColumnNew = (
  data,
  setSelectedKeys,
  selectedKeys,
  confirm,
  nameColumn,
  nameInStore,
  columnDate,
  dateRange,
  notRangeInFilter
) => {
  let rowValues = [];

  if (columnDate) {
    rowValues = [
      ...new Set(
        data?.map(item => {
          if (item[nameColumn]) {
            if (dateRange) {
              const date = item[nameColumn].split(',');
              return `${moment(date[0]).format('DD-MM-YYYY')} / ${moment(date[1]).format('DD-MM-YYYY')}`;
            } else {
              return moment(item[nameColumn]).format('DD-MM-YYYY');
            }
          } else {
            return 'нет значения';
          }
        })
      ),
    ].map(item => {
      return { label: item, value: item };
    });
  } else if (nameInStore) {
    rowValues = DirectoryStore[nameInStore]?.map(item => {
      return { label: item.name, value: item.id };
    });
  } else {
    rowValues = [
      ...new Set(
        data?.map(item => {
          if (item[nameColumn] !== null) {
            return item[nameColumn];
          } else {
            return 'нет значения';
          }
        })
      ),
    ].map(item => {
      return { label: item, value: item };
    });
  }

  const onChangeFilter = checked => {
    setSelectedKeys(checked);
  };

  const onCheckAll = e => {
    if (e.target.checked) {
      const allValues = rowValues.map(item => item.value);
      setSelectedKeys(allValues);
    } else {
      setSelectedKeys();
    }
  };

  const searchFilter = e => {
    const searchValues = rowValues.map(item => {
      if (e.target.value && item.label.toString().toLowerCase().includes(e.target.value.toString().toLowerCase())) {
        return item.value;
      }
      return null;
    });
    setSelectedKeys(searchValues);
  };

  const getFilter = () => {
    confirm();
  };

  const resetFilter = () => {
    setSelectedKeys();
  };

  const getRangeDate = e => {
    if (e) {
      const arrDate = data.map(item => {
        return moment(item[nameColumn]).format('DD-MM-YYYY');
      });

      let newArrDate = [];
      arrDate.map(item => {
        if (moment(item, 'DD-MM-YYYY').isBetween(moment(e[0]._d, 'DD-MM-YYYY'), moment(e[1]._d, 'DD-MM-YYYY'))) {
          newArrDate.push(item);
        }
        return null;
      });

      setSelectedKeys(newArrDate);
    }
  };

  return (
    <div className='filterInColumn__wrapper'>
      {columnDate && !notRangeInFilter && (
        <div className='RangePickerWrapper'>
          <RangePicker className='RangePicker' onChange={e => getRangeDate(e)} />
        </div>
      )}
      <Input className='filterInColumn__input' placeholder='Поиск в фильтре' onChange={searchFilter}></Input>
      <Checkbox className='CheckAllChange' onChange={onCheckAll}>
        Check all
      </Checkbox>
      <Checkbox.Group
        className='filterInColumn__checkboxGroup'
        options={rowValues}
        value={selectedKeys}
        // defaultValue={userfields}
        onChange={onChangeFilter}
      />
      <div className='filterInColumn__btns'>
        <Button className='filterInColumn__btn' type='link' danger size='small' onClick={resetFilter}>
          Reset
        </Button>
        <Button className='filterInColumn__btn' type='primary' size='small' onClick={getFilter}>
          Ok
        </Button>
      </div>
    </div>
  );
};

export default getFiltersInColumnNew;
